import React from "react";
import { HiArrowLeft } from "react-icons/hi";
import CustomProgressBar from "components/AudioPlayer/Components/CustomProgressBar";
import { formatDurationHr_Min_Sec } from "utils/timeFunctions";
import AnimatedText from "components/shared/AnimatedText";

function PlayerSection({
  currentSong,
  fullScreen,
  setFullScreen,
  music,
  radio,
  podcast,
  progress,
  onSeek,
  currentTime,
  duration,
  controlSection,
}: any) {
  const handleFullScreen = () => {
    setFullScreen(!fullScreen);
  };

  const screenHeight = window.innerHeight - 110;
  const getHeight = (part: number) => {
    return `${screenHeight * part}px`;
  };

  const artwork = music
    ? currentSong?.artwork_url
    : podcast
    ? currentSong?.podcast?.artwork_url
    : "";

  return (
    <>
      {/* header */}
      <div
        className="flex w-full items-center justify-between p-[1%]"
        style={{ height: `${getHeight(0.15)}` }}
      >
        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-2xl text-black transition-colors hover:bg-white/90"
          onClick={handleFullScreen}
          aria-label="Minimize"
        >
          <HiArrowLeft />
        </button>
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-white/60">
          Playing Now
        </div>
        <div className="w-10" />
      </div>

      {/* artwork */}
      <div
        className="flex items-center justify-center"
        style={{ height: `${getHeight(0.4)}` }}
      >
        <div
          className="overflow-hidden rounded-2xl shadow-[0_24px_70px_rgba(0,0,0,0.6)] ring-1 ring-white/10"
          style={{ width: getHeight(0.4), height: getHeight(0.4) }}
        >
          {artwork && (
            <img
              src={artwork}
              alt=""
              className="h-full w-full object-cover"
            />
          )}
        </div>
      </div>

      {/* song details */}
      {(music || podcast) && (
        <div
          style={{ height: `${getHeight(0.2)}` }}
          className="flex items-center justify-center px-6 text-center"
        >
          <div className="min-w-0">
            {currentSong?.title && currentSong?.title?.length < 35 ? (
              <p className="truncate text-2xl font-bold text-white">
                {currentSong?.title}
              </p>
            ) : (
              <div className="flex w-full justify-center">
                <AnimatedText
                  text={currentSong?.title}
                  classname={`text-left text-[16px] text-white scroll-text-full-screen max-md:hidden`}
                />
              </div>
            )}

            <p className="mt-2 text-lg text-[#7B9DB4] max-sm:text-base">
              {music && currentSong?.artists && currentSong?.artists[0]?.name}
              {podcast && currentSong?.artist && currentSong?.artist?.name}
            </p>
          </div>
        </div>
      )}

      {/* progress bar */}
      <div
        className="flex w-full items-center justify-between gap-3"
        style={{ height: `${getHeight(0.1)}` }}
      >
        <p className="min-w-[50px] text-center text-sm tabular-nums text-white/60 max-md:hidden">
          {currentTime ? formatDurationHr_Min_Sec(currentTime) : "00:00"}
        </p>
        <CustomProgressBar
          progress={progress}
          onSeek={onSeek}
          fullScreen={fullScreen}
        />
        <p className="min-w-[50px] text-center text-sm tabular-nums text-white/60 max-md:hidden">
          {duration ? formatDurationHr_Min_Sec(duration) : "00:00"}
        </p>
      </div>

      {/* controls */}
      <div
        className="flex items-center justify-center gap-4 md:w-full"
        style={{ height: `${getHeight(0.1)}` }}
      >
        {controlSection}
      </div>

      <hr className="border-t border-white/10" />
    </>
  );
}

export default PlayerSection;